import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Subscription  {
    _originalTypeClassName = "zAppDevManager.BO.Subscription";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Subscription.translate = translateService;
}
this.Applications = [];
this.Administratorts = [];
this.Users = [];
this.Rights = [];
this.Activations = [];
this.Id = null;
this.Name = null;
this.PlanName = null;
this.LimitationsId = null;
this.ExpirationDate = null;
this.ZVeltonSubscriptionId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
PlanName:any;
LimitationsId:any;
ExpirationDate:any;
ZVeltonSubscriptionId:any;
Applications:any;
Administratorts:any;
Users:any;
Limitations:any;
SubscriptionPlan:any;
Rights:any;
Activations:any;
DatabaseInfo:any;
static setApplications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Applications == null) $this.Applications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Applications.length > 0) {
                    Domain.Subscription.removeApplications($this, $this.Applications[0]);
                }

                Domain.Subscription.addManyApplications($this, copyItems);
            }
static addManyApplications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addApplications($this, items[i]);
                }
            }
static addApplications = ($this, item) => {
                if ($this.Applications == null) $this.Applications = [];
                if (item == null || $this.Applications.indexOf(item) > -1) return;
                $this.Applications.push(item);
}
static addRangeApplications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addApplications($this, item));
            }
static removeApplications = ($this, item) => {
                if ($this == null || $this.Applications == null || $this.Applications.indexOf(item) === -1) return;
                var _index = $this.Applications.indexOf(item);
                $this.Applications.splice(_index, 1);
}
static clearApplications = ($this) => { $this.Applications = null; }
static setAdministratorts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Administratorts == null) $this.Administratorts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Administratorts.length > 0) {
                    Domain.Subscription.removeAdministratorts($this, $this.Administratorts[0]);
                }

                Domain.Subscription.addManyAdministratorts($this, copyItems);
            }
static addManyAdministratorts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addAdministratorts($this, items[i]);
                }
            }
static addAdministratorts = ($this, item) => {
                if ($this.Administratorts == null) $this.Administratorts = [];
                if (item == null || $this.Administratorts.indexOf(item) > -1) return;
                $this.Administratorts.push(item);
}
static addRangeAdministratorts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addAdministratorts($this, item));
            }
static removeAdministratorts = ($this, item) => {
                if ($this == null || $this.Administratorts == null || $this.Administratorts.indexOf(item) === -1) return;
                var _index = $this.Administratorts.indexOf(item);
                $this.Administratorts.splice(_index, 1);
}
static clearAdministratorts = ($this) => { $this.Administratorts = null; }
static setUsers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Users == null) $this.Users = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Users.length > 0) {
                    Domain.Subscription.removeUsers($this, $this.Users[0]);
                }

                Domain.Subscription.addManyUsers($this, copyItems);
            }
static addManyUsers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addUsers($this, items[i]);
                }
            }
static addUsers = ($this, item) => {
                if ($this.Users == null) $this.Users = [];
                if (item == null || $this.Users.indexOf(item) > -1) return;
                $this.Users.push(item);
}
static addRangeUsers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addUsers($this, item));
            }
static removeUsers = ($this, item) => {
                if ($this == null || $this.Users == null || $this.Users.indexOf(item) === -1) return;
                var _index = $this.Users.indexOf(item);
                $this.Users.splice(_index, 1);
}
static clearUsers = ($this) => { $this.Users = null; }
static setLimitations = ($this, value) => {
var oldValue = $this.Limitations;
$this.Limitations = value;
if (value != null) {
}
}
static setSubscriptionPlan = ($this, value) => {
var oldValue = $this.SubscriptionPlan;
$this.SubscriptionPlan = value;
if (value != null) {
}
}
static setRights = ($this, items) => {
                if (items == null) items = [];
                if ($this.Rights == null) $this.Rights = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Rights.length > 0) {
                    Domain.Subscription.removeRights($this, $this.Rights[0]);
                }

                Domain.Subscription.addManyRights($this, copyItems);
            }
static addManyRights = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addRights($this, items[i]);
                }
            }
static addRights = ($this, item) => {
                if ($this.Rights == null) $this.Rights = [];
                if (item == null || $this.Rights.indexOf(item) > -1) return;
                $this.Rights.push(item);
}
static addRangeRights = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addRights($this, item));
            }
static removeRights = ($this, item) => {
                if ($this == null || $this.Rights == null || $this.Rights.indexOf(item) === -1) return;
                var _index = $this.Rights.indexOf(item);
                $this.Rights.splice(_index, 1);
}
static clearRights = ($this) => { $this.Rights = null; }
static setActivations = ($this, items) => {
                if (items == null) items = [];
                if ($this.Activations == null) $this.Activations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Activations.length > 0) {
                    Domain.Subscription.removeActivations($this, $this.Activations[0]);
                }

                Domain.Subscription.addManyActivations($this, copyItems);
            }
static addManyActivations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addActivations($this, items[i]);
                }
            }
static addActivations = ($this, item) => {
                if ($this.Activations == null) $this.Activations = [];
                if (item == null || $this.Activations.indexOf(item) > -1) return;
                $this.Activations.push(item);
}
static addRangeActivations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addActivations($this, item));
            }
static removeActivations = ($this, item) => {
                if ($this == null || $this.Activations == null || $this.Activations.indexOf(item) === -1) return;
                var _index = $this.Activations.indexOf(item);
                $this.Activations.splice(_index, 1);
}
static clearActivations = ($this) => { $this.Activations = null; }
static setDatabaseInfo = ($this, value) => {
var oldValue = $this.DatabaseInfo;
$this.DatabaseInfo = value;
if (value != null) {
}
}

static SerializeRow(row: any): any{let s = new Domain.Subscription();
s.Id = Joove.Common.cast(row.get("SubscriptionId"), "number");
s.Name = Joove.Common.cast(row.get("SubscriptionName"), "string");
if (row.has("SubscriptionPlanName")) {s.PlanName = Joove.Common.cast(row.get("SubscriptionPlanName"), "string");}
if (row.has("ExpirationDate")) {s.ExpirationDate = Joove.Common.cast(row.get("ExpirationDate"), "Date");}
if (row.has("ZVeltonSubscriptionId")) {if (Joove.Common.cast(row.get("ZVeltonSubscriptionId"), "object") != null) {let dd = (Joove.Common.cast(row.get("ZVeltonSubscriptionId"), "object"));if (!(CLMS.Framework.String.IsNullOrEmpty((dd?.toString() ?? '').trim())) && dd?.toString() != "null") {s.ZVeltonSubscriptionId = Joove.Common.cast(dd, "number");}}else {}}
if (row.has("SubscriptionLimitationsId")) {if (row.get("SubscriptionLimitationsId") != null) {try {s.LimitationsId = Joove.Common.cast(row.get("SubscriptionLimitationsId"), "number");}catch (e) {}}}
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}